import EventBus from '../event-bus'
import jQuery from 'jquery'

const XhrErrorMessage = {
    
    bindEvents() {

        EventBus.subscribe('xhr-error-message', (params) => {
            
            let response = JSON.parse(params.xhr.responseText)
            
            //WordPress compatability
            if (response.hasOwnProperty('data')) {
                response = response.data
            }
            
            const
                message = response.hasOwnProperty('errors') ? response.errors : (response.hasOwnProperty('message') ? response.message : null),
                messages = [],
                errorHash = {}
            
            switch (typeof message) {
                
                case 'array':
                case 'object':
                
                    var i = 0
                
                    jQuery.each(message, (key, error) => {
                        
                        if (!errorHash.hasOwnProperty(error)) {
                            errorHash[error] = true
                            messages.push(error)
                        }
                        
                        i ++
                        
                    });
                    
                break;
                
                case 'string':
                    messages.push(message)
                break;
            
            }
            
            //Apply default
            if (messages.length === 0) {
                messages.push(params.hasOwnProperty('default') ? params.default : (typeof defaultAjaxError != 'undefined' ? defaultAjaxError : 'Something went wrong. Please try again.'))
            }
            
            params.callback(messages)
            
        });
        
    }
    
}

XhrErrorMessage.bindEvents()

export default XhrErrorMessage